/**
 * @generated SignedSource<<79b4a9d3f34ca1c7326521708f144428>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LessonAnswerPollQuery$variables = {
  id: string;
};
export type LessonAnswerPollQuery$data = {
  readonly node: {
    readonly answers?: ReadonlyArray<{
      readonly cueIndex: number;
      readonly transcript: string | null | undefined;
    }>;
  } | null | undefined;
};
export type LessonAnswerPollQuery = {
  response: LessonAnswerPollQuery$data;
  variables: LessonAnswerPollQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LessonAnswer",
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cueIndex",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "transcript",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LessonPlay",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonAnswerPollQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonAnswerPollQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e198d0cbeddd3cb5ea37747bc1969478",
    "id": null,
    "metadata": {},
    "name": "LessonAnswerPollQuery",
    "operationKind": "query",
    "text": "query LessonAnswerPollQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on LessonPlay {\n      answers {\n        cueIndex\n        transcript\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6fb3a3714373dc0fad35a3c6342d1fde";

export default node;
